import { render, staticRenderFns } from "./servicesList.vue?vue&type=template&id=04773749&scoped=true&"
import script from "./servicesList.vue?vue&type=script&lang=js&"
export * from "./servicesList.vue?vue&type=script&lang=js&"
import style0 from "./servicesList.vue?vue&type=style&index=0&id=04773749&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04773749",
  null
  
)

export default component.exports